import { Box, Container, Typography, Stack, Button } from "@mui/material";
import { menuEdmonton, menuRedDeer } from "../images";
import { useMemo, useState } from "react";
import MetaTags from "../components/MetaTags";

export default function Drinks() {
  const [city, setCity] = useState<"edmonton" | "reddeer">("edmonton");

  const menuSrc = useMemo(() => {
    return city === "edmonton" ? menuEdmonton : menuRedDeer;
  }, [city]);

  const title = city === "edmonton" ? "CoCo Edmonton Menu" : "CoCo Red Deer Menu";

  return (
    <Box sx={{ py: { xs: 3, md: 5 } }}>
      <MetaTags title={title} description="A menu of CoCo drinks" url={window.location.href} />

      <Container maxWidth="lg">
        <Stack spacing={2} alignItems="center" sx={{ mb: 2 }}>

          {/* Optional city toggle (if you actually want both menus available) */}
          <Stack direction="row" spacing={1}>
            <Button
              variant={city === "edmonton" ? "contained" : "outlined"}
              onClick={() => setCity("edmonton")}
            >
              Edmonton
            </Button>
            <Button
              variant={city === "reddeer" ? "contained" : "outlined"}
              onClick={() => setCity("reddeer")}
            >
              Red Deer
            </Button>
          </Stack>

          {/* Optional download/open full size */}
          <Button component="a" href={menuSrc} target="_blank" rel="noreferrer">
            Open Full Size
          </Button>
        </Stack>

        <Box
          component="img"
          alt={`${title} image`}
          src={menuSrc}
          loading="lazy"
          decoding="async"
          sx={{
            width: "100%",
            height: "auto",
            display: "block",
            borderRadius: { xs: 1, md: 2 },
            boxShadow: 2,
            backgroundColor: "background.paper",
          }}
        />
      </Container>
    </Box>
  );
}